export default __webpack_public_path__ + "static/media/watch1.864e0215.jpg";